import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux';
import icon_logo from '../img/phone_login.png';
import icon_logo_company from '../img/ccm_icon.png';
import "./login.scss";
import { useDispatch } from 'react-redux'
import { set } from '../slicers/keySlicer'
import { change } from '../slicers/selectedStepSlicer'

import Cookies from 'universal-cookie';
const cookies = new Cookies(null, { path: '/' });


export default function LoginPage({ w }) {
    const [inputLogin, setInputLogin] = useState("");
    const [inputPassword, setInputPassword] = useState("");
    const [authError, setauthError] = useState(false);
    const [privateToken, setPrivateToken] = useState('');
    const [publicToken, setPublicToken] = useState('');
    const [authErrorMsg, setauthErrorMsg] = useState('');
    const dispatch = useDispatch()
    function auth_send_private() {
        const body = {
            'UserLogin': inputLogin,
            'UserPassword': inputPassword
        }
        let xhr = new XMLHttpRequest();
        let url = new URL(`${process.env.REACT_APP_BASEURL}auth/generate-private-key`);
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'json';
        xhr.send(JSON.stringify(body));
        xhr.onload = () => {
            if (xhr.status == 200) {
                setPrivateToken(xhr.response['id'])
                console.log(inputLogin)

            }
            if (xhr.status == 404 || xhr.status == 400) {
                setauthError(true)
                console.log(privateToken)
                setauthErrorMsg('Введен неверный логин или пароль')
                console.log(xhr.response)
            }
            if (xhr.status == 403) {
                setauthError(true)
                setauthErrorMsg('Учётная запись заблокирована')
            }
        }



    }

    function auth_send_public() {
        const body = {
            'PrivateKeyId': privateToken
        }
        let xhr = new XMLHttpRequest();
        let url = new URL(`${process.env.REACT_APP_BASEURL}auth/generate-public-key`);
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'json';
        xhr.send(JSON.stringify(body));
        xhr.onload = () => {
            if (xhr.status == 200) {
                const response = xhr.response.id
                dispatch(set(response))
                setPublicToken(response)
                cookies.set('privateToken', privateToken);

            }
            if (xhr.status == 404 || xhr.status == 400) {
                console.log(privateToken)
                setauthErrorMsg('Введен неверный логин или пароль')
                console.log(xhr.response)
            }
            if (xhr.status == 403) {
                setauthError(true)
                setauthErrorMsg('Учётная запись заблокирована')
            }
        }
    }

    useEffect(() => {
        if (privateToken != '') {
            auth_send_public()
        }
    }, [privateToken])
    useEffect(() => {
        if (publicToken != "") {
            dispatch(change(0))
        }
    }, [publicToken])
    try {
        return (

            <>
            <div className="background-container">

                <div className="main">

                    <h1 className='title_login'>Зарплатный учёт</h1>
                    <h4>Введите ваши учетные данные</h4>
                    {authError && <h5 className='errorMessage'>{authErrorMsg}</h5>}
                    <form action="">
                        <label className='lables_login'>
                            Логин:
                        </label>
                        <input className='inputs_login' type="text" value={inputLogin} onChange={(e) => setInputLogin(e.target.value)}
                            placeholder="Введите имя пользователя" />

                        <label className='lables_login'>
                            Пароль:
                        </label>
                        <input className='inputs_login' type="password" value={inputPassword} onChange={(e) => setInputPassword(e.target.value)}
                            placeholder="Введите пароль" />

                        <div className="wrap">
                            <button className='button_login' type="button" onClick={(e) => { auth_send_private() }}>
                                Отправить
                            </button>
                        </div>
                    </form>
                </div>
                <div>
                    <div className="wave"></div>
                    <div className="wave"></div>
                    <div className="wave"></div>
                </div>
            </div>
            
            </>
        );
    }
    catch (error) {
    }
}
